<!-- Overlay for mobile -->

<!-- Sidebar -->
@if (isOpen$ | async; as isOpen) {
  <aside
    class="w-64 bg-white text-gray-900 z-31 h-full flex flex-col rounded-tr-2xl rounded-br-2xl px-[24px] py-[48px]"
    [class.fixed]="isOpen"
    [class.absolute]="!isOpen"
    [class.hidden]="!isOpen"
    [class.md:flex]="!isOpen"
  >
    <div class="flex flex-col h-full">
      <div class="flex items-center justify-center w-full">
        <!-- Logo -->
        @if (companyLogoUrl()) {
          <img class="h-9 w-auto mb-6" [src]="companyLogoUrl()" alt="Company logo" />
        }
      </div>
      <nav class="flex-1 flex flex-col gap-6 py-4 overflow-y-auto">
        @for (section of sidebarSections; track section.label) {
          <!-- Section title -->
          <div>
            <p class="mb-2 text-[12px] font-bold uppercase text-caption_light">
              {{ section.label | translate }}
            </p>

            <!-- Section items -->
            <ul class="space-y-1">
              @for (item of section.items; track item.label) {
                <li>
                  <!-- ITEM CON HIJOS -->
                  @if (item.children?.length) {
                    <button
                      type="button"
                      class="flex w-full items-center justify-between rounded-[14px] p-[8px] text-[14px] hover:bg-gray-100 cursor-pointer"
                      (click)="toggleSubMenu(item)"
                    >
                      <span class="flex items-center gap-2">
                        @if (item.icon) {
                          <i [class]="item.icon" class="text-[14px]"></i>
                        }
                        {{ item.label | translate }}
                      </span>
                      <i
                        class="fas fa-chevron-down transition-transform"
                        [class.rotate-180]="item.isExpanded"
                      ></i>
                    </button>

                    @if (item.isExpanded) {
                      <ul class="mt-1 space-y-1 pl-4">
                        @for (child of item.children; track child.label) {
                          <li>
                            <a
                              [routerLink]="child.route"
                              [routerLinkActive]="['bg-primary', 'text-white']"
                              (click)="onCloseSidebar()"
                              class="block text-caption_dark rounded-[14px] p-[8px] text-[14px] hover:bg-gray-100"
                            >
                              {{ child.label | translate }}
                            </a>
                          </li>
                        }
                      </ul>
                    }
                  }

                  <!-- ITEM SIMPLE -->
                  @else {
                    <a
                      [routerLink]="item.route"
                      [routerLinkActive]="['bg-primary', 'text-white']"
                      (click)="onCloseSidebar()"
                      class="flex items-center gap-2 p-[8px] text-caption_dark rounded-[14px] text-[14px] hover:bg-primary hover:text-white"
                    >
                      @if (item.icon) {
                        <i [class]="item.icon" class="text-[14px]"></i>
                      }
                      {{ item.label | translate }}
                    </a>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </nav>

      <div class="mt-auto pt-4">
        <button
          type="button"
          (click)="onLogout()"
          class="flex w-full items-center gap-2 p-[8px] text-[14px] text-error cursor-pointer rounded-[14px] hover:bg-error_light"
        >
          <i class="fas fa-right-from-bracket"></i>
          {{ 'Cerrar sesión' | translate }}
        </button>
      </div>

      <!-- Notification Toggle Switch 
      <div class="border-t border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div class="text-gray-600">
            <i class="fas fa-bell"></i>
          </div>
          <div class="relative inline-flex">
            <div
              (click)="toggleNotifications(!notificationsEnabled())"
              class="w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer"
              [class.bg-blue-500]="notificationsEnabled()"
              [class.bg-gray-300]="!notificationsEnabled()"
            >
              <div
                class="bg-white h-4 w-4 rounded-full shadow-md transform duration-300 ease-in-out"
                [class.translate-x-6]="notificationsEnabled()"
                [class.translate-x-0]="!notificationsEnabled()"
              ></div>
            </div>
          </div>
        </div>
      </div>-->
    </div>
  </aside>
}
